module.exports = __webpack_public_path__ + "static/bmw-m4-front-grill-grey-allstocksociety-600px-39903cb9a4763ce5ee499d867a95bff4.jpg";